import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import InvoiceEntry from './components/InvoiceEntry';
import ActivityLogs from './components/ActivityLogs';
import Settlement from './components/Settlement';
import SalesHistory from './components/SalesHistory';
import theme from './theme';
// GSTReport import moved to the route where it's used
// Removed unused import for StockEntry

// Removed duplicate PrivateRoute definition

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/entry/:entryId" element={<PrivateRoute><InvoiceEntry /></PrivateRoute>} />
          <Route path="/entry" element={<PrivateRoute><InvoiceEntry /></PrivateRoute>} />
          <Route 
            path="/logs" 
            element={
              <PrivateRoute>
                <AdminRoute>
                  <ActivityLogs />
                </AdminRoute>
              </PrivateRoute>
            }
          />
          <Route 
            path="/settlement" 
            element={
              <PrivateRoute>
                <AdminRoute>
                  <Settlement />
                </AdminRoute>
              </PrivateRoute>
            }
          />
          <Route 
            path="/gst-report" 
            element={
              <PrivateRoute>
                <AdminRoute>
                  {React.createElement(React.lazy(() => import('./components/GSTReport')))}
                </AdminRoute>
              </PrivateRoute>
            } 
          />
          <Route 
            path="/sales-history" 
            element={
              <PrivateRoute>
                <AdminRoute>
                  <SalesHistory />
                </AdminRoute>
              </PrivateRoute>
            }
          />
          {/* Add a root route that redirects based on auth status */}
          <Route
            path="/"
            element={
              <AuthRedirect />
            }
          />
          {/* Keep the catch-all for any other undefined routes, redirecting to root */}
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

// Component to handle redirection based on authentication status
function AuthRedirect() {
  const { currentUser } = useAuth();
  return currentUser ? <Navigate to="/dashboard" /> : <Navigate to="/login" />;
}

// Component to protect admin routes
function AdminRoute({ children }) {
  const { currentUser } = useAuth();
  if (!currentUser || currentUser.email !== 'admin@brewzcoffee.in') {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

export default App;
